module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.userIsAuthenticated === false) ? _c('div', {
    staticClass: "mv2 pa3 br1 flex justify-between f4 b--red bg-washed-red",
    attrs: {
      "data-v-a23099b6": "",
      "data-v-67cdb7dd": ""
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("Your Claims")]), _vm._v(" "), (_vm.user.membership_status === 'CANCELED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing\n          team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Inquiry Regarding Banned Account"
    }
  }, [_vm._v("please\n          contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e()], 1) : _c('div', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v(_vm._s(_vm.$t('titles.allclaims', {
    allclaims: 'All Claims'
  })))]), _vm._v(" "), (_vm.userHasAccess && !_vm.draft_claims.length) ? _c('div', {
    staticClass: "mv3 mw5-ns"
  }, [_c('ak-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.fileclaim.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('titles.addclaims', {
    addclaims: 'File New Claim'
  })))])], 1) : _vm._e(), _vm._v(" "), (_vm.all_claims) ? _c('div', [_c('div', {
    staticClass: "grid-one mt4 mb3 mb4-ns"
  }, _vm._l((_vm.all_claims), function(claim, claim_index) {
    return _c('div', {
      key: claim_index
    }, [_c('ak-claim-card-v2', {
      attrs: {
        "id": claim.id,
        "version": claim.version,
        "description": claim.description,
        "devices": claim.devices,
        "filedOn": claim.filed_on,
        "knownDamage": claim.known_damage,
        "lossDay": claim.loss_day,
        "lossMonth": claim.loss_month,
        "lossType": claim.loss_type,
        "lossYear": claim.loss_year,
        "status": claim.status,
        "claimDevices": claim.claim_devices
      }
    })], 1)
  }), 0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fw5 mid-gray dark-red",
    attrs: {
      "data-v-a23099b6": ""
    }
  }, [_c('span', {
    attrs: {
      "data-v-67cdb7dd": "",
      "data-v-a23099b6": ""
    }
  }, [_vm._v("Your account still has not been activated. Please complete activation before filing a claim. ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "data-v-67cdb7dd": "",
      "href": "/account-activation/step1",
      "data-v-a23099b6": ""
    }
  }, [_vm._v("Click here to\n        complete setup.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e142109","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimsV2Page.vue
// module id = 1408
// module chunks = 0